module.exports = __webpack_public_path__ + "img/LogoText.e47156d6.svg";